import { money } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tag, Check, X } from "lucide-react";

// Community-submission review list. Presentational: state + handlers come from the parent.
export const SubmissionsTab = ({ submissions, approveSub, rejectSub }) => {
  if (submissions.length === 0) {
    return <p className="text-muted-foreground">No pending submissions. Community deals will appear here for review.</p>;
  }
  return (
    <div className="space-y-3">
      {submissions.map((d) => (
        <div key={d.deal_id} data-testid={`submission-${d.deal_id}`} className="flex items-center gap-4 rounded-xl border border-black/10 bg-white p-4">
          {d.image_url ? (
            <img src={d.image_url} alt="" className="h-16 w-16 rounded-lg object-cover shrink-0" />
          ) : (
            <div className="h-16 w-16 rounded-lg bg-secondary flex items-center justify-center shrink-0">
              <Tag className="h-5 w-5 text-muted-foreground" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <Badge className="bg-primary text-primary-foreground border-none">{d.deal_type}</Badge>
              <span className="text-xs text-muted-foreground">by {d.submitted_by_name || "user"} · {d.source}</span>
            </div>
            <h3 className="mt-1 font-heading text-lg truncate" style={{ fontWeight: 600 }}>{d.title}</h3>
            <p className="text-sm text-muted-foreground truncate">
              {d.retailer} · {money(d.original_price)}{d.description ? ` — ${d.description}` : ""}
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <Button data-testid={`approve-sub-${d.deal_id}`} onClick={() => approveSub(d.deal_id)} className="rounded-full">
              <Check className="mr-1 h-3.5 w-3.5" /> Approve
            </Button>
            <Button variant="outline" data-testid={`reject-sub-${d.deal_id}`} onClick={() => rejectSub(d.deal_id)}
              className="rounded-full text-destructive hover:text-destructive">
              <X className="mr-1 h-3.5 w-3.5" /> Reject
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubmissionsTab;
